import { render, staticRenderFns } from "./AliasEditModal.vue?vue&type=template&id=281735ae&scoped=true&"
import script from "./AliasEditModal.vue?vue&type=script&lang=ts&"
export * from "./AliasEditModal.vue?vue&type=script&lang=ts&"
import style0 from "./AliasEditModal.vue?vue&type=style&index=0&id=281735ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281735ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VForm,VTextField})
